import { useQuery } from '@tanstack/react-query';
import { fetchShipmentModifiedByDetails } from '../../data-provider/select-options';
import type { GetShipmentModifiedByDetailsRequestParams } from '../../data-provider/select-options/shipment-modified-by-details/api';

export const useGetShipmentModifiedByDetails = ({
  companyId,
  ...params
}: { companyId?: number } & GetShipmentModifiedByDetailsRequestParams) => {
  return useQuery({
    queryKey: ['shipment-types', params.modifiedByType],
    queryFn: () => fetchShipmentModifiedByDetails(params),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
    enabled: params.modifiedByType >= 0 && !!companyId,
  });
};
